import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_chevronBreadcrumb",
  "use": "icon_chevronBreadcrumb-usage",
  "viewBox": "0 0 5 9",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 5 9\" id=\"icon_chevronBreadcrumb\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M.283.947a.973.973 0 011.367 0l2.9 2.875a.952.952 0 010 1.356l-2.9 2.875a.973.973 0 01-1.367 0 .953.953 0 010-1.356L2.5 4.5.283 2.303a.953.953 0 010-1.356z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol